/**
 * Organization branding service — CE stub (no-op).
 * CE edition does not have org branding; this stub maintains API compatibility.
 */

export interface OrgBranding {
  name: string;
  code: string;
  hasLogo: boolean;
  logoUrl: string;
}

type Listener = () => void;

class OrgBrandingService {
  private listeners = new Set<Listener>();

  async init(): Promise<void> { /* no-op in CE */ }

  get(): OrgBranding | null { return null; }
  getBranding(): OrgBranding | null { return null; }
  async refresh(): Promise<void> { /* no-op */ }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => { this.listeners.delete(listener); };
  }

  getLogoUrl(): string { return ''; }
}

export const orgBrandingService = new OrgBrandingService();
